'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    title: '商品编号',
    dataIndex: 'id',
    key: 'id'
}, {
    title: '默认图',
    dataIndex: 'thumb',
    key: 'thumb',
    render: function render(text) {
        return _react2.default.createElement('img', { className: 'thumb', src: text + '!160x160' });
    }
}, {
    title: '商品名称',
    key: 'name',
    render: function render(text, record) {
        return record.title + ' \u2014\u2014 ' + record.subTitle;
    }
}, {
    title: '商品类型',
    key: 'type',
    render: function render(text, record) {
        return record.type.name;
    }
}, {
    title: '序号',
    dataIndex: 'sort',
    key: 'sort'
}, {
    title: '状态',
    key: 'status',
    render: function render(text, record) {
        return record.status === 1 ? '上架' : '下架';
    }
}, {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at'
}, {
    title: '操作',
    key: 'action',
    render: function render(text, record) {
        return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/products/' + record.id },
                '\u7F16\u8F91'
            ),
            _react2.default.createElement('span', { className: 'ant-divider' }),
            _react2.default.createElement(
                'a',
                { onClick: record.handleStatusChange.bind(null, record.id, record.status) },
                record.status === 1 ? '下架' : '上架'
            )
        );
    }
}];

var ProductList = _react2.default.createClass({
    displayName: 'ProductList',

    propTypes: {
        products: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var _this = this;

        var _props = this.props,
            products = _props.products,
            handleStatusChange = _props.handleStatusChange;
        var items = products.items,
            pagination = products.pagination,
            error = products.error,
            isFetching = products.isFetching;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                item.handleStatusChange = handleStatusChange;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var pager = Object.assign(_constants.PaginationConfig, {
            total: pagination.total,
            current: pagination.current_page,
            pageSize: pagination.per_page,
            onChange: function onChange(page, pageSize) {
                // 页码改变的回调，参数是改变后的页码及每页条数   
                _this.props.onChange(page);
            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pager,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = ProductList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_list.js
// module id = 1478
// module chunks = 0